<template>
    <WizardTabWithSidebar
        sidebar-background-image="https://superangels.club/wp-content/uploads/2020/07/ESAC_2020_invest_connect_smart_mobility_72dpi_1600x1200_landscape_BACKGROUND_ONLY.jpg">
        <template #main>
            <WizardHeader title="Manager and Beneficial Owner - Personal Information" :icon="UsersIcon"></WizardHeader>
            <ManagerListItem class="border-y border-gray-200 px-2 py-2" :manager="currentManager"></ManagerListItem>
            <div class="px-4 pt-3 sm:px-6">
                <AddLegalManagerBeneficialOwnerForm
                    v-model="currentManager"
                    :disable-email="currentNewManager !== null"
                    :is-manager="true"></AddLegalManagerBeneficialOwnerForm>
            </div>
        </template>
        <template #nextButton>
            <BaseButtonPrimary
                :disabled="formState.currentForm && formState.currentForm.hasValidationErrors"
                size="lg"
                @click="submit()"
                >{{ $t('widget.save') }}
            </BaseButtonPrimary>
        </template>
        <template #previousButton>
            <BaseButtonMuted size="lg" @click="navigateToPreviousTab()">{{ $t('widget.back') }}</BaseButtonMuted>
        </template>

        <template #sidebar>
            <p class="pb-2 pb-2 text-base text-gray-800">
                {{ $t('esac_widget_sidebar.legal_manager_two_personal') }}
            </p>
        </template>
    </WizardTabWithSidebar>
</template>

<script setup lang="ts">
import WizardTabWithSidebar from '../../WizardTabWithSidebar.vue'
import WizardHeader from '../../WizardHeader.vue'
import BaseButtonPrimary from '../../../base/BaseButtonPrimary.vue'
import BaseButtonMuted from '../../../base/BaseButtonMuted.vue'
import { useLegalAccountFormState } from '../../../../utilities/account/useAccountFormLegal'
import { inject, onMounted, ref } from 'vue'
import { UsersIcon } from '@heroicons/vue/outline'
import { useLegalAccountDataState } from '../../../../utilities/account/useAccountDataLegal'
import ManagerListItem from '../../../account/legal/managers/ManagerListItem.vue'
import AddLegalManagerBeneficialOwnerForm from './form/LegalManagerBeneficialOwnerForm.vue'
import { postManager, putManager } from '../../../../utilities/api'
import { LegalPerson } from './form/forms'
import { currentNewManager } from './manager'

const formState = useLegalAccountFormState()
const { navigateToNextTab, navigateToPreviousTab } = inject('navigation')

const currentManager = ref(new LegalPerson())

onMounted(() => {
    if (currentNewManager.value) {
        currentManager.value = currentNewManager.value
    }
})

async function submit() {
    const { valid } = await formState.currentForm.validate()
    if (valid) {
        if (currentNewManager.value) {
            const response = await putManager(currentManager.value.natural_profile_uid, currentManager.value)
            currentNewManager.value = response.data
        } else {
            const response = await postManager(
                useLegalAccountDataState().legalProfile.legal_profile_uid,
                currentManager.value
            )
            currentNewManager.value = response.data
        }
        navigateToNextTab()
    }
}
</script>

<style scoped></style>
